import React from 'react';
import { Form } from 'react-bootstrap';
import { Paragraph2 } from '../../../theme/styles';

// NOTE: The intense JSDOC is for TSX support, that said is it 100% valid

/**
 * TextInput -- A text input based on Bootstrap's Form.Control
 * @param {object} props Parent of props below
 * @param {boolean} [props.feedbackTooltip = false] Should the feedback tooltip be shown?
 * @param {string} props.id The id of the input
 * @param {boolean} [props.isInvalid = false] Is the input invalid?
 * @param {boolean} [props.isValid] Is the input valid?
 * @param {function} props.onChange The onChange handler
 * @param {function} [props.onKeyDown] The onKeyDown handler
 * @param {string} [props.placeholder = ''] The placeholder text
 * @param {boolean} [props.showLockIconOnDisabled = false] Should the lock icon be shown when the input is disabled?
 * @param {string} [props.type = 'text'] The type of input
 * @param {string} [props.validPattern = '.*'] The regex pattern to validate the input
 * @param {string} [props.value = ''] The value of the input
 * @param {object} [props.props = {}] Any additional props past in
 *
 * @returns {JSX.Element} A text input based on Bootstrap's Form.Control
 */
const TextInput = ({
    feedbackTooltip = undefined,
    id,
    isInvalid = false,
    isValid,
    onChange,
    onKeyDown,
    showLockIconOnDisabled = false,
    type = 'text',
    validPattern = '.*',
    value,
    ...props
}) => (
    <Form.Group
        className="position-relative mb-0 w-100"
    >
        <Form.Control
            id={id}
            className={showLockIconOnDisabled ? 'input-locked' : ''}
            style={Paragraph2}
            type={type || 'text'}
            value={value || ''}
            pattern={validPattern}
            isInvalid={isInvalid}
            isValid={isValid}
            onChange={onChange}
            onKeyDown={onKeyDown}
            {...props}
        />
        {feedbackTooltip && (
            <Form.Control.Feedback type="invalid" tooltip>
                {feedbackTooltip}
            </Form.Control.Feedback>
        )}

    </Form.Group>
);

export default TextInput;
